/* template */
<template><div :class="(externClass)" class="ts-container"><template v-if="(isLoaded)"><slot name="bg-icon"></slot><div class="ts-header" v-if="(slot.header)"><ts-navbar :fullScreen="(fullScreen)" :navbarStyle="(navbarStyle)" :titleStyle="(titleStyle)" :fillboxStyle="(fillboxStyle)" :useDefaultBack="(useDefaultBack)" :leftArrow="(leftArrow)" :left="(left)" :useWebBack="(navbarUseWebBack)" :title="(navbarTitle)" :isDropdown="(isDropdown)" :isFixed="(isFixed)" :dropdownStyle="(dropdownStyle)" @clickright="clickRight" @clickleft="clickLeft" v-if="(useDefaultNavbar && !hideNavBar)"><div slot="right" v-if="(navbarUseRight)"><slot name="narbar-right"/></div></ts-navbar><slot name="header" v-else></slot></div><slot name="prepend"></slot><div :style="[(mainStyle)] | transRpxStyle" class="ts-main"><div ref="__mpx_ref_scrollerfixed__" class="ts-scroller-fixed" v-if="(anchorList.length)"><slot name="scroller-fixed"></slot></div><mpx-scroll-view id="ts-main-scroller" :scroll-y="(enableScroll)" :scroll-top="(scrollTop)" :scroll-into-view="(scrollIntoView)" @scroll="scrollHandle" @scrolltoupper="scrollToTopHandle" @scrolltolower="scrollToBottomHandle" :scroll-with-animation="(scrollWithAnimation)" :refresher-enabled="(useRefresher)" :refresher-default-style="(refresherDefaultStyle)" :refresher-triggered="(refresherTriggered)" @refresherrefresh="refresherrefresh" @refresherpulling="refresherpulling" :refresher-background="(refresherbackground)" class="ts-main-scroller"><div slot="refresher" class="pulldown"><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/Hc2LzFVPzU1652950957080.png" class="pulldown-loading" v-if="(!isRestore)"/><div class="pulldown-text">{{ refreshText }}</div></div><ts-polyfill-page :type="(blankPageType)" :loadingContext="(loadingContext)" :blankButtonContext="(blankButtonContext)" :blankContextTitle="(blankContextTitle)" :blankContextSubTitle="(blankContextSubTitle)" :loadingImageUrl="(loadingImageUrl)" :blankImageUrl="(blankImageUrl)" :hasButton="(hasBlankButton)" :hasSubTitle="(hasBlankSubTitle)" :hasTitle="(hasBlankTitle)" :setBlankContext="(setBlankContext)" @click-button="clickButton" :blank-title-style="(blankTitleStyle)" :blank-subtitle-style="(blankSubtitleStyle)" :categoryLoadingTitle="(categoryLoadingTitle)" :categoryLoadingDesc="(categoryLoadingDesc)" v-if="(useBlankPage)"><div slot="blankContextTitle"><slot name="blankContext"/></div></ts-polyfill-page><slot v-else></slot></mpx-scroll-view></div><div :style="[(footerStyle)] | transRpxStyle" class="ts-footer" v-if="(slot.footer)"><slot name="footer"></slot></div></template><div class="skeleton-container" v-else><slot name="skeleton"/></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m2d572556"}'>
  .ts-container
    display flex
    flex-direction column
    height 100%
    flex 1
    flex-basis auto
    box-sizing border-box
    min-width 0
  .skeleton-container
    width 100vw
    height 100vh
    overflow hidden
  .ts-header
    display flex
    flex-direction column
  .ts-main
    flex 1
    overflow-y auto
    background #F3F4F5
  .ts-scroller-fixed
    width 100%
    position absolute
    z-index 2
    top 0
    left 0
  .ts-main-scroller
    height 100%
    width 100%
  .ts-footer
    display flex
  .pulldown
    display flex
    justify-content center
    align-items center
    width 100%
    height 56px
    background #1473FF
    .pulldown-text
      font-size 14px
      color #FFFFFF
      padding-right 28px
    .pulldown-loading
      width 20px
      height 20px
      margin-right 15px
      animation spin 2s linear infinite
    @keyframes spin
      0%
        transform rotate(0deg)
      100%
        transform rotate(360deg)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m2d572556"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex2d572556%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex2d572556%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m2d572556"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index2d572556/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'ts-polyfill-page':getComponent(require("../ts-polyfill-page/index.mpx?isComponent&outputPath=components%2Findex15c39454%2Findex")),'ts-navbar':getComponent(require("../ts-navbar/index.mpx?isComponent&outputPath=components%2Findex268d26bb%2Findex")),'mpx-scroll-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-scroll-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
